
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createHead } from "@vueuse/head"


import {createApp} from 'vue';

require('./bootstrap');


import App from './App.vue';
import axios from 'axios';
import router from './router';
import auth from './auth';
import { createI18n } from 'vue-i18n';
import en from '../lang/en.json';
import ar from '../lang/ar.json';
import { getLocaleFromURL } from './locale.js';
import Vuex from 'vuex';
import store from './components/cart_item/store'; // Replace with the actual path to your store
import { vue3Debounce } from 'vue-debounce'


// Vue.use(createI18n);

const i18n = new createI18n({
    locale: getLocaleFromURL(), // Set the default language
    fallbackLocale: 'en', // Fallback language if translation is missing
    messages: {
        en, // English translations
        ar, // Arabic translations
    },
});

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(router);
const options = {
    // You can set your default options here
    timeout: false,
    rtl: true,
    closeButton: false,
    position: "top-right",
    // hideProgressBar: true,
};
//
app.use(Toast, options);


app.use(auth, {
    afterChecked: function(){
        // app.mount('#app');
    }
})

const head = createHead()

app.use(head);
app.use(i18n);
app.use(store);

app
    .directive('debounce', vue3Debounce({ lock: true }))
    .mount('#app');

// إضافة معالج الأخطاء
// app.config.errorHandler = function (err, vm, info) {
//     console.error('Error: ', err);
//     console.error('Info: ', info);
//     // يمكنك إضافة الكود اللازم هنا لتسجيل الأخطاء أو عرض إشعارات للمستخدم
// };
